import CheckSymbol from 'components/elements/symbols/CheckSymbol'
import React from 'react'
import styled from 'styled-components'

/**
 * 単体破損箇所、オーバーレイ+チェックマーク
 */
const DamagedPartCheck: React.FC<DamagedPartCheckProps> = (props) => {
  return (
    <StyledDamagedPartCheck onClick={props.onClick}>
      <BoxOverlay isDamaged={props.isDamaged} />
      <CheckSymbolWrapper
        left={props.left}
        right={props.right}
        top={props.top}
        bottom={props.bottom}
      >
        <CheckSymbol isChecked={props.isDamaged} />
      </CheckSymbolWrapper>
    </StyledDamagedPartCheck>
  )
}

export type DamagedPartCheckProps = PartPositionProps & {
  isDamaged: boolean
  onClick?: (event: React.MouseEvent<HTMLElement, MouseEvent>) => void
}

export type PartPositionProps = {
  left?: string
  right?: string
  top?: string
  bottom?: string
}

const StyledDamagedPartCheck = styled.div`
  position: relative;
  height: 100%;
`

const BoxOverlay = styled.div<{
  isDamaged: boolean
}>`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: ${(props): string =>
    props.isDamaged ? 'var(--color-main)' : 'transparent'};
  opacity: 0.16;
`

const CheckSymbolWrapper = styled.div<PartPositionProps>`
  position: absolute;
  ${(props): string => (props.left ? `left: ${props.left};` : '')}
  ${(props): string => (props.right ? `right: ${props.right};` : '')}
  ${(props): string => (props.top ? `top: ${props.top};` : '')}
  ${(props): string => (props.bottom ? `bottom: ${props.bottom};` : '')}
`

export default DamagedPartCheck
